const join = {
    join: '$t({{left}}) $t({{right}})',
    andJoin: '$t({{left}}) and $t({{right}})',
    slashJoin: '$t({{left}})/$t({{right}})',
    unitJoin: '$t({{value}}) ($t(unit:{{unit}}))'
};
const letterCase = {
    capital: '$t({{value, capital}})',
    upper: '$t({{value, upper}})',
    lower: '$t({{value, lower}})'
};
export default Object.assign({}, join, letterCase);
